import { toast } from "react-hot-toast"

import { setUser } from "../../slices/profileSlice"
import { apiConnector } from "../apiconnector"
import { settingsEndpoints } from "../apis"
import { logout } from "./authAPI"

const {
  UPDATE_DISPLAY_PICTURE_API,
  UPLOAD_PICTURE_API,
  UPDATE_PROFILE_API,
  CHANGE_PASSWORD_API,
  DELETE_PROFILE_API,
} = settingsEndpoints

export function updateDisplayPicture(formData) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    try {
      const response = await apiConnector(
        "PUT",
        UPDATE_DISPLAY_PICTURE_API,
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      )
      
      if (!response.success) {
        throw new Error(response.message)
      }
      toast.success("Display Picture Updated Successfully")
      dispatch(setUser(response.data))
    } catch (error) {
      toast.error("Could Not Update Display Picture")
    }
    toast.dismiss(toastId)
  }
}

export async function uploadPicture( formData) {
  try {
    const response = await apiConnector(
      "POST",
      UPLOAD_PICTURE_API,
      formData,
      
    );

    if (!response || !response.success) {
      throw new Error(response?.message || "Upload failed");
    }

    toast.success("Image Uploaded Successfully");
    return response; // ✅ Ensure the response is returned

  } catch (error) {
    console.error("UPLOAD_PICTURE_API API ERROR:", error);
    toast.error("Could Not Upload Picture");
    return null; // ✅ Return null in case of failure
  }
}


export function updateProfile(formData) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    try {
      const response = await apiConnector("PUT", UPDATE_PROFILE_API, formData)
      
      if (!response.success) {
        throw new Error(response.message)
      }
      const userImage = response.updatedUserDetails.image
        ? response.updatedUserDetails.image
        : `https://api.dicebear.com/5.x/initials/svg?seed=${response.updatedUserDetails.firstName} ${response.updatedUserDetails.lastName}`
      dispatch(
        setUser({ ...response.updatedUserDetails, image: userImage })
      )
      toast.success("Profile Updated Successfully")
    } catch (error) {
        toast.error("Could Not Update Profile")
    }
    toast.dismiss(toastId)
  }
}

export async function changePassword(formData) {
  const toastId = toast.loading("Loading...")
  try {
    const response = await apiConnector("POST", CHANGE_PASSWORD_API, formData)
    
    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    toast.success("Password Changed Successfully")
  } catch (error) {
    toast.error(error.response.data.message)
  }
  toast.dismiss(toastId)
}

export function deleteProfile(navigate) {
  return async (dispatch) => {
    const toastId = toast.loading("Loading...")
    try {
      const response = await apiConnector("DELETE", DELETE_PROFILE_API, null)
      
      if (!response.success) {
        throw new Error(response.message)
      }
      toast.success("Profile Deleted Successfully")
      dispatch(logout(navigate))
    } catch (error) {
      toast.error("Could Not Delete Profile")
    }
    toast.dismiss(toastId)
  }
}